import { Component, OnInit, EventEmitter, Output, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import {AuthService} from "../services/auth.service";
import {Observable} from "rxjs";
import * as moment from "moment-timezone";
import {Moment} from "moment-timezone";
import {ApiService} from "../services/api.service";

@Component({
  selector: 'app-private-layout',
  templateUrl: './private-layout.component.html',
  styleUrls: ['./private-layout.component.scss']
})
export class PrivateLayoutComponent implements OnInit {

  @Output() dateChange = new EventEmitter();

  @Output() typeChange = new EventEmitter();

  public user$!: Observable<any>;

  public date: any = moment();

  public type: any;

  public isCollapsed = true;

  private userId: any;

  public userBloodGroup: any;

  public userPast: number = 0;

  public screenWidth: number = 0;

  public screenHeight: number = 0;

  constructor(public _router: Router,
              private _apiService: ApiService,
              private _authService: AuthService,
              ) {}

  ngOnInit(): void {

    let past:number = 0;

    this.user$ = this._authService.user$;

    this._authService.user$.subscribe( params => { this.userId = params['id']; this.userBloodGroup = params['bloodGroup'];  } );

    if(this.userBloodGroup == null ){

      this.userBloodGroup = "empty";

    }

    this._apiService.getUserReservations(this.userId).subscribe((response: any) => {

      response.reservation.forEach(function (value:any) {

        if ( moment(value.till).isBefore(moment()) ){

          past = past + 1;

        }

      });

      this.userPast = past;

    });

    this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;

  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
  }

  onSelectDate($event: any){
    this._router.navigate(['/user']);
    this.date = moment($event);
    this.dateChange.emit($event);
  }

  onSelectType($event: any){
    this.type = $event;
    this.typeChange.emit($event);
  }

  logout(){
    this._apiService.logout().subscribe((response: any) => {
      localStorage.removeItem('accessToken');
      this._authService.unauthenticate();
      this._router.navigate(['/login']);
    });

  }

}
